import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/home/Home.vue' //首页
import Login from './views/login/Login.vue' //登录
import EnterpriseRegister from './views/enterprise-register/enterprise-register.vue' //企业注册
import DarenRegister from './views/daren-register/daren-register.vue' //达人注册
import DarenAttestation from './views/daren-attestation/attestation.vue' //达人填写资料
import Daren from './views/daren/daren.vue' //达人管理
import Enterprise from './views/enterprise/enterprise.vue' //企业管理
import Operator from './views/operator/operator.vue' //企业管理
import Investment from './views/investment/Investment.vue'//招商加盟
import NewHome from './views/newhome/NewHome.vue'//新的home
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ // 滚动条滚动的行为，不加这个默认就会记忆原来滚动条的位置
    y: 0
  }),
  routes: [
    {
      path: '/',
      name: 'Newhome',
      component: NewHome
    },
    {
      path: '/addd',
      name: 'home',
      component: Home
    },
    {
      path: '/list',
      name: 'List',
      component: () => import('./views/list/List.vue')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('./views/about/about.vue')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('./views/register/Register.vue')
    },
    {
      // 招商
      path:'/investment',
      name:'Investment',
      component: Investment
      // component:() => import('./views/investment/Home.vue')
    },
    // newhome
    {
      path:'/newhome',
      name:'NewHome',
      component:NewHome
    },
    {
      path: '/operator',
      name: 'Operator',
      component: Operator
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/enterprise-register',
      name: 'EnterpriseRegister',
      component: EnterpriseRegister,
      children: [
        {
          path: 'attestation',
          name: 'EnterpriseAttestation',
          component: () => import('./views/enterprise-register/attestation/attestation.vue')
        },
        {
          path: 'result',
          name: 'EnterpriseResult',
          component: () => import('./views/enterprise-register/result/result.vue')
        }
      ]
    },
    {
      path:'/daren-attestation',
      name:'DarenAttestation',
      component:DarenAttestation
    },
    {
      path: '/daren-register',
      name: 'DarenRegister',
      component: DarenRegister,
      children: [
        {
          path: 'attestation',
          name: 'DarenAttestation',
          component: () => import('./views/daren-register/attestation/attestation.vue')
        },
        {
          path: 'select',
          name: 'DarenSelect',
          component: () => import('./views/daren-register/select/select.vue')
        },
        {
          path: 'offline',
          name: 'Offline',
          component: () => import('./views/daren-register/offline/offline.vue')
        },
        {
          path: 'online',
          name: 'Online',
          component: () => import('./views/daren-register/online/online.vue')
        },
        {
          path: 'result',
          name: 'DarenResult',
          component: () => import('./views/daren-register/result/result.vue')
        }
      ]
    },
    {
      path: '/introduce/:id',
      name: 'Introduce',
      component: () => import('./views/introduce/introduce.vue')
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('./views/detail/detail.vue')
    },
    {
      path: '/daren',
      name: 'Daren',
      component: Daren,
      children: [
        {
          path: 'info',
          name: 'DarenInfo',
          component: () => import('./views/daren/info/info.vue')
        },
        {
          path: 'order',
          name: 'DarenOrder',
          component: () => import('./views/daren/order/order.vue')
        },
        {
          path: 'manage',
          name: 'DarenManage',
          component: () => import('./views/daren/manage/manage.vue')
        },
        {
          path: 'balance',
          name: 'DarenBalance',
          component: () => import('./views/daren/balance/balance.vue')
        },
        {
          path: 'detail',
          name: 'DarenOrderDetail',
          component: () => import('./views/daren/detail/detail.vue')
        },
        {
          path: 'message',
          name: 'DarenMessage',
          component: () => import('./views/daren/message/message.vue')
        },
        {
          path: 'use',
          name: 'DarenUse',
          component: () => import('./views/daren/use/use.vue')
        },
        {
          path: 'agent',
          name: 'DarenValet',
          component: () => import('./views/daren/agent/agent.vue')
        },
        {
          path: 'agentEdit',
          name: 'DarenAgentEdit',
          component: () => import('./views/daren/agentEdit/agentEdit.vue')
        },
        {
          path: 'agentDetail',
          name: 'agentDetail',
          component: () => import('./views/daren/agentDetail/agentDetail.vue')
        },
        {
          path: 'again',
          name: 'darenAgain',
          component: () => import('./views/daren/again/again.vue')
        },
        {
          path: 'release',
          name: 'DarenRelease',
          component: () => import('./views/daren/release/release.vue')
        },
        {
          path: 'edit',
          name: 'DarenEdit',
          component: () => import('./views/daren/edit/edit.vue')
        }
      ]
    },
    {
      path: '/enterprise',
      name: 'Enterprise',
      component: Enterprise,
      children: [
        {
          path: 'manage',
          name: 'EnterpriseManage',
          component: () => import('./views/enterprise/manage/manage.vue')
        },
        {
          path: 'info',
          name: 'EnterpriseInfo',
          component: () => import('./views/enterprise/info/info.vue')
        },
        {
          path: 'account',
          name: 'EnterpriseAccount',
          component: () => import('./views/enterprise/account/account.vue')
        },
        {
          path: 'order',
          name: 'EnterpriseOrder',
          component: () => import('./views/enterprise/order/order.vue')
        },
        {
          path: 'reward',
          name: 'EnterpriseReward',
          component: () => import('./views/enterprise/reward/reward.vue')
        },
        {
          path: 'balance',
          name: 'EnterpriseBalance',
          component: () => import('./views/enterprise/balance/balance.vue')
        },
        {
          path: 'recharge',
          name: 'Recharge',
          component: () => import('./views/enterprise/recharge/recharge.vue')
        },
        {
          path: 'release',
          name: 'Release',
          component: () => import('./views/enterprise/release/release.vue')
        },
        {
          path: 'edit',
          name: 'Edit',
          component: () => import('./views/enterprise/edit/edit.vue')
        },
        {
          path: 'again',
          name: 'Again',
          component: () => import('./views/enterprise/again/again.vue')
        },
        {
          path: 'detail',
          name: 'EnterpriseExtensionDetail',
          component: () => import('./views/enterprise/detail/detail.vue')
        },
        {
          path: 'agentEdit',
          name: 'agentEdit',
          component: () => import('./views/enterprise/agentEdit/agentEdit.vue')
        },
        {
          path: 'payment',
          name: 'payment',
          component: () => import('./views/enterprise/payment/payment.vue')
        },
        {
          path: 'message',
          name: 'EnterpriseMessage',
          component: () => import('./views/enterprise/message/message.vue')
        },
        {
          path: 'use',
          name: 'EnterpriseUse',
          component: () => import('./views/enterprise/use/use.vue')
        }
      ]
    }
  ]
});

export default router
